import { type StorageInterface } from 'core/infra/storage/StorageInterface'

import sentry from 'legacy/utils/sentry'

import { type UserRepository } from 'auth/infra/userRepository'

import { SG_ALL_IN_ONE_STORAGE_TOKEN_KEY } from '../domain/User'

type AllInOneUserRepositoryDeps = {
  storage: StorageInterface
}

export class AllInOneUserRepository implements UserRepository {
  private storage: StorageInterface

  constructor({ storage }: AllInOneUserRepositoryDeps) {
    this.storage = storage
  }

  getLocalToken() {
    try {
      return this.storage.get<string>(SG_ALL_IN_ONE_STORAGE_TOKEN_KEY)
    } catch (error) {
      sentry.log(error)
    }
  }

  setLocalToken(token: string) {
    this.storage.set(SG_ALL_IN_ONE_STORAGE_TOKEN_KEY, token)
  }
}
